import { Api } from "@/plugins/api"
import { mapGetters, mapMutations } from "vuex"
export default {
    data() {
        return {
            credentials: {
                numero: "",
                codePostal: "",
            },
            loginLoading: false,
            loginError: false
        }
    },
    computed: {
        ...mapGetters(["account", "loggedIn", "prenomNom"])
    },
    methods: {
        ...mapMutations(["SET_ACCOUNT_LOGIN", "LOGOUT"]),

        login() {
            if (!this.$refs.authForm.validate()) {
                return
            }
            this.loginLoading = true
            let credentials = this.credentials
            Api.post("auth/login", credentials)
                .then((res) => {
                    this.SET_ACCOUNT_LOGIN(res.data)
                })
                .catch((res) => {
                    console.log(res)
                    this.loginError = true
                })
                .finally(() => {
                    this.loginLoading = false
                })
        },
        loginWithToken() {
            if (this.$route.query.token) {
                this.loginLoading = true
                const token = this.$route.query.token.replace(/\s/g, "+")
                const encodedToken = encodeURIComponent(token)
                Api.post(`auth/login-with-token?token=${encodedToken}`)
                    .then((res) => {
                        this.SET_ACCOUNT_LOGIN(res.data)
                    })
                    .catch((res) => {
                        console.log(res)
                        this.loginError = true
                    })
                    .finally(() => {
                        this.loginLoading = false
                    })
            }
        },
        async authWithToken() {
            if (this.$route.query.token) {
                this.loginLoading = true
                const token = this.$route.query.token.replace(/\s/g, "+")
                const encodedToken = encodeURIComponent(token)
                try{
                    const result = await Api.get(`auth/auth-with-token?token=${encodedToken}`)
                    return result.data
                }
                catch(ex) {
                    console.log(ex)
                    this.loginError = true
                }
                finally {
                    this.loginLoading = false
                }
            }
            else {
                this.loginError = true
            }
        },
        logout() {
            this.LOGOUT()
        }
    }
}